import React, {Component} from 'react';
import {login} from '../../util/APIUtils';
import './Login.css';
import {Link} from 'react-router-dom';
import {ACCESS_TOKEN} from '../../constants';

import {Form, Input, Button, Icon, notification, Modal} from 'antd';
import {Col, Label, Row} from "reactstrap";

const FormItem = Form.Item;

class Login extends Component {
	render() {
		const AntWrappedLoginForm = Form.create()(LoginForm);
		return (
			<Row className='ogo-login-background' style={{backgroundImage: 'url(' + process.env.REACT_APP_CONTEXT_NAME + "/image/background.jpg" + ')', marginLeft: "0px", marginRight: "0px"}}>
				<Col xs='12' className="ogo-login-container">
					<Col xs='12' style={{padding: '0 0 15px 0', textAlign: 'center'}}>
						<img src={process.env.REACT_APP_CONTEXT_NAME + "/image/img.png"} alt='oda-logo' className='ogo-login-logo'/>
					</Col>
					<AntWrappedLoginForm onLogin={this.props.onLogin}/>
				</Col>
			</Row>
		);
	}
}

class LoginForm extends Component {
	constructor(props) {
		super(props);
		this.state = {
			show: false,
		}
		this.handleSubmit = this.handleSubmit.bind(this);
		this.showModal = this.showModal.bind(this);
		this.handleOk = this.handleOk.bind(this);
	}

	showModal = () => {
		this.setState({
			visible: true,
		});
	};

	handleOk = () => {
		this.setState({
			visible: false,
		});
	};

	handleSubmit(event) {
		event.preventDefault();
		this.props.form.validateFields((err, values) => {
			if (!err) {
				const loginRequest = Object.assign({}, values);
				login(loginRequest)
					.then(response => {
						localStorage.setItem(ACCESS_TOKEN, response.data.accessToken);
						this.props.onLogin();
					}).catch(error => {
					notification.error({
						message: 'ŞanlıUrfa Eczacı Odası',
						description: 'Kullanıcı Adı veya Şifre Yanlış! Lütfen Yeniden Deneyiniz.'
					});
				});
			}
		});
	}

	render() {
		const {getFieldDecorator} = this.props.form;
		return (
			<Form onSubmit={this.handleSubmit} className="login-form">
				<FormItem>
					{getFieldDecorator('usernameOrEmail', {
						rules: [{required: true, message: 'Kullanıcı Adı veya Eposta Giriniz.'}],
					})(
						<Input
							prefix={<Icon type="user"/>}
							size="large"
							name="usernameOrEmail"
							placeholder="Kullanıcı Adı veya Eposta"/>
					)}
				</FormItem>
				<FormItem>
					{getFieldDecorator('password', {
						rules: [{required: true, message: 'Lütfen Şifre Giriniz!'}],
					})(
						<Input
							prefix={<Icon type="lock"/>}
							size="large"
							name="password"
							type="password"
							placeholder="Şifre"/>
					)}
				</FormItem>
				<FormItem>
					<div className="login-buttons">
						<Button type="primary" htmlType="submit" size="medium" className="login-form-button">Giriş</Button>
						{/*<Link to="/signup">*/}
						{/*	<Button type="default" size="medium" className="signup-form-button">Hesap Oluştur</Button>*/}
						{/*</Link>*/}
					</div>
				</FormItem>
				<div className="row col-sm-12 center">
					<Label style={{color: "white", fontWeight: "bold", fontSize: "12px"}} className="col-sm-12">Bilgilendirme: Üyelik kaydı sırasında odanıza bildirmiş olduğunuz e-mail adresiniz sisteme tanımlanmıştır.</Label>
				</div>

				<div className="row col-sm-12 center">
					<Link className="col-sm-12 white" to="/resetPassword">Şifremi Unuttum</Link>
				</div>
				<Modal
					title="ŞanlıUrfa Eczacı Odası Bilgilendirme"
					visible={this.state.visible}
					okText="Tamam"
					footer={[
						<Button key="submit" type="primary" onClick={this.handleOk}>
							Tamam
						</Button>,
					]}
					onOk={this.handleOk}
					onCancel={this.handleOk}
				>
					<p><h4>Üyelik başvurusu sırasında Odaya bildirdiğiniz e-posta adresiyle işlem yapabilirsiniz.
						Şifrenizi bilmiyorsanız "Şifremi Unuttum" linkinden şifrenizi sıfırlayınız.</h4></p>

				</Modal>
			</Form>
		);
	}
}

export default Login;



// WEBPACK FOOTER //
// ./src/page/login/Login.js